import React from "react";
import { FaPizzaSlice, FaHamburger } from "react-icons/fa";
import { GiNoodles, GiChopsticks } from "react-icons/gi";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const Category = () => {
  return (
    <List>
      <Slink to={"/cuisine/italian"}>
        <FaPizzaSlice />
        <h4>Italian</h4>
      </Slink>

      <Slink to={"/cuisine/american"}>
        <FaHamburger />
        <h4>American</h4>
      </Slink>

      <Slink to={"/cuisine/thai"}>
        <GiNoodles />
        <h4>Thai</h4>
      </Slink>

      <Slink to={"/cuisine/African"}>
        <GiChopsticks />
        <h4>African</h4>
      </Slink>
    </List>
  );
};

const List = styled.div`
  display: flex;
  justify-content: center;
`;
const Slink = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 50%;
  background: linear-gradient(35deg, #494949, #313131);
  width: 6rem;
  height: 6rem;
  transform: scale(0.6);
  color: #fff;
  transition: 0.2s ease-out;
  h4 {
    padding: 0.5rem;
    font-size: 0.9rem;
  }
  svg {
    font-size: 1.5rem;
  }
  &.active {
    background: linear-gradient(to right, #f27121, #e94057);
    transform: scale(0.6);
    margin-top: -10px;
  }
  @media screen and (max-width: 400px) {
    width: 5rem;
    height: 5rem;
    svg {
      font-size: 1rem;
    }
    h4 {
      font-size: 0.7rem;
    }
  }
`;
export default Category;
